/* eslint-disable react/no-unknown-property */
import React from 'react';
import ProductConatiner from './ProductContainer/ProductConatiner';
import ProductInputForm from './ProductInputForm/ProductInputForm';

function Main() {
  return (
    <main className="py-16">
      <div className="productWrapper">
        {/* <!-- products container --> */}
        <ProductConatiner/>
        {/* <!-- products container ends --> */}
        <ProductInputForm />
      </div>
    </main>
  );
}

export default Main;
